import { createFileRoute } from "@tanstack/react-router"

import { MarketingExportFormPage } from "@/pages/marketing-export-form"

export const Route = createFileRoute("/(marketing)/marketing/exports/$taskId")({
	staticData: {
		breadcrumbKey: "navigation.breadcrumbs.exportEdit",
	},
	component: function MarketingExportEditRoute() {
		const { taskId } = Route.useParams()
		return <MarketingExportFormPage mode="edit" taskId={taskId} />
	},
})
